import { Fragment } from 'react';

// Group words in pairs, or a final group of three, so a line cannot contain
// a lone word. Keep the original wording and spaces around colored spans.
export function headingText(value) {
  if (typeof value !== 'string') return value;
  const words = value.trim().split(/\s+/);
  if (words.length < 2) return value;
  const groups = [];
  for (const sentence of value.trim().split(/(?<=[.!?])\s+/)) {
    const sentenceWords = sentence.split(/\s+/);
    for (let i = 0; i < sentenceWords.length;) {
      const count = sentenceWords.length - i === 3 ? 3 : 2;
      groups.push(sentenceWords.slice(i, i + count).join(' '));
      i += count;
    }
  }
  return <>{/^\s/.test(value) ? ' ' : ''}{groups.map((text, index) => <Fragment key={index}>{index ? ' ' : ''}<span className="heading-phrase">{text}</span></Fragment>)}{/\s$/.test(value) ? ' ' : ''}</>;
}
